<template>
  <div class="silde_box">
    <slide-verify class="silde_box" :imgs="img" ref="block" @again="onAgain" @success="onSuccess" @fail="onFail"
      @refresh="onRefresh"></slide-verify>
    <div class="text">{{ msg }}</div>
  </div>

</template>

<script lang="ts" setup>
import { ref } from "vue";
// 局部注册组件，需要单独引用组件样式
// 只提供局部引用的方式，不再采用插件形式，方便按需加载，减少主包大小
import SlideVerify, { SlideVerifyInstance } from "vue3-slide-verify";
import "vue3-slide-verify/dist/style.css";
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const emits = defineEmits(['handle'])
const msg = ref("");
const block = ref<SlideVerifyInstance>();

//自定义图片
const img = ref(["/img/slidelogin1.png", "/img/slidelogin2.png", "/img/slidelogin3.png", "/img/slidelogin4.png", "/img/slidelogin5.png", "/img/slidelogin6.png"])
const onAgain = () => {
  msg.value = t('setup30');
  // 刷新
  block.value?.refresh();
};

const onSuccess = (times: number) => {
  emits('handle')
  msg.value = `login success, ${(times / 1000).toFixed(1)}s`;
};

const onFail = () => {
  msg.value = " ";
};

const onRefresh = () => {

  // msg.value = "点击了刷新小图标";
};

const handleClick = () => {
  // 刷新
  block.value?.refresh();
  msg.value = "";
};
</script>
<style scoped lang='scss'>
.silde_box {
  margin: 0 auto;
  padding-bottom: 30px;

  .text {
    text-align: center;
  }
}
</style>